import { useNavigate } from "react-router-dom";
import AssetCard from "./AssetCard";
import { Asset } from "@/types/assets";

interface AssetListProps {
  assets: Asset[];
  onRefresh: () => void;
}

export function AssetList({ assets, onRefresh }: AssetListProps) {
  const navigate = useNavigate();

  const getFirstImageUrl = (images: string | null): string | undefined => {
    if (!images) return undefined;
    const imageUrls = images.split(',').filter(Boolean);
    return imageUrls.length > 0 ? imageUrls[0] : undefined;
  };

  return (
    <div className="mt-8 space-y-4">
      {assets.map((asset) => (
        <div key={asset.id}>
          <AssetCard
            id={asset.id}
            name={asset.name || asset.asset_name || "Unnamed Asset"}
            imageUrl={getFirstImageUrl(asset.images)}
            isShared={asset.shared_assets && asset.shared_assets.length > 0}
            status={asset.status}
            onShare={onRefresh}
            onEdit={() => navigate(`/assets/${asset.id}/edit`)}
            asset_name={asset.asset_name}
            asset_description={asset.asset_description}
            asset_contact={asset.asset_contact}
            asset_price={asset.asset_price}
            category={asset.category}
            code={asset.code}
            internal_asset_id={asset.internal_asset_id}
            location={asset.location}
            nfc_id={asset.nfc_id}
            notes={asset.notes}
            phone={asset.phone}
            private_code={asset.private_code}
            purchase_date={asset.purchase_date}
            qr_id={asset.qr_id}
            serial_number={asset.serial_number}
            warranty_expiry={asset.warranty_expiry}
            user_name={asset.user_name}
            company={asset.company}
            place={asset.place}
            images={asset.images}
            documents={asset.documents}
            latitude={asset.latitude}
            longitude={asset.longitude}
          />
        </div>
      ))}
    </div>
  );
}